import { postMethod } from "../post";
import { Api } from "../../config/config";

export const api_UpdateAllToMemory = () => {
  var url = `${Api}/?ControllerName104=ApiUpdate`;
  return postMethod(url, '{"SERVICENAME":"UpdateAllToMemory"}');
};

export const api_LoadMobileSettingsToMemory = () => {
  var url = `${Api}/?ControllerName104=ApiUpdate`;
  return postMethod(url, '{"SERVICENAME":"LoadMobileSettingsToMemory"}');
};

export const api_LoadMerchantInfoListToMemory = () => {
  var url = `${Api}/?ControllerName104=ApiUpdate`;
  return postMethod(url, '{"SERVICENAME":"LoadMerchantInfoListToMemory"}');
};

export const api_LoadCategoryAndProductListToMemory = () => {
  var url = `${Api}/?ControllerName104=ApiUpdate`;
  return postMethod(
    url,
    '{"SERVICENAME":"LoadCategoryAndProductListToMemory"}'
  );
};

export const api_UpdateRunningSaleOrderMemory = () => {
  var url = `${Api}/?ControllerName104=ApiUpdate`;
  return postMethod(url, '{"SERVICENAME":"UpdateRunningSaleOrderMemory"}');
};

export const api_LoadFrequentryBoughtProductListToMemory = () => {
  var url = `${Api}/?ControllerName104=ApiUpdate`;
  return postMethod(
    url,
    '{"SERVICENAME":"LoadFrequentryBoughtProductListToMemory"}'
  );
};

export const api_LoadZoneToMemory = () => {
  var url = `${Api}/?ControllerName104=ApiUpdate`;
  return postMethod(url, '{"SERVICENAME":"LoadZoneToMemory"}');
};

export const api_LoadMapLocationsToMemmory = () => {
  var url = `${Api}/?ControllerName104=ApiUpdate`;
  return postMethod(url, '{"SERVICENAME":"LoadMapLocationsToMemmory"}');
};

export const api_LoadPromoToMemory = () => {
  var url = `${Api}/?ControllerName104=ApiUpdate`;
  return postMethod(url, '{"SERVICENAME":"LoadPromoToMemory"}');
};

export const api_LoadMobileUrlToMemmory = () => {
  var url = `${Api}/?ControllerName104=ApiUpdate`;
  return postMethod(url, '{"SERVICENAME":"LoadMobileUrlToMemmory"}');
};

export const api_WriteMemoryDataForTesting = () => {
  var url = `${Api}/?ControllerName104=ApiUpdate`;
  return postMethod(url, '{"SERVICENAME":"WriteMemoryDataForTesting"}');
};
